import React, { useEffect, useState } from 'react';
import {
  subscribeCandidateState,
  commitCandidate,
} from '../../services/marathiTransliterationService';
import './MarathiCandidateOverlay.css';

export default function MarathiCandidateOverlay() {
  const [candidateState, setCandidateState] = useState({
    visible: false,
    candidates: [],
    selectedIndex: 0,
    position: { top: 0, left: 0 },
  });

  useEffect(() => {
    const unsubscribe = subscribeCandidateState(next => {
      setCandidateState(next);
    });
    return unsubscribe;
  }, []);

  if (!candidateState.visible || !candidateState.candidates || candidateState.candidates.length === 0) {
    return null;
  }

  const { position, candidates, selectedIndex } = candidateState;

  return (
    <div
      className="marathi-candidate-overlay"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
      }}
      role="listbox"
      aria-label="मराठी शब्द पर्याय"
    >
      <span className="marathi-candidate-badge">मराठी</span>
      {candidates.map((cand, idx) => {
        const isSelected = idx === selectedIndex;
        return (
          <button
            key={`${cand}-${idx}`}
            type="button"
            className={`marathi-candidate-item ${isSelected ? 'selected' : ''}`}
            onMouseDown={e => {
              // Prevent losing focus on the input before commit
              e.preventDefault();
            }}
            onClick={e => {
              e.preventDefault();
              commitCandidate(idx, false);
            }}
            role="option"
            aria-selected={isSelected}
          >
            <span className="marathi-candidate-num">{idx + 1}.</span>
            <span className="marathi-candidate-text">{cand}</span>
          </button>
        );
      })}
      <span className="marathi-candidate-help" title="Space: पहिला पर्याय | 1-5: क्रमांक निवडा | Esc: इंग्रजीत ठेवा">
        Space ↵
      </span>
    </div>
  );
}
